// Application Insights bootstrap. Best-effort: if the connection string
// is empty (local dev outside Docker), telemetry is a no-op.

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { config } from "./config";

let initialised = false;

export function initTelemetry(): void {
  if (initialised) return;
  if (!config.appInsightsConnectionString) return;

  const ai = new ApplicationInsights({
    config: {
      connectionString: config.appInsightsConnectionString,
      enableAutoRouteTracking: true,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: false,
      enableResponseHeaderTracking: false,
      disableExceptionTracking: false,
      // No ai_user/ai_session cookies: GDPR decision 2026-11-04 (monitoring plan 5.5).
      disableCookiesUsage: true,
    },
  });
  ai.loadAppInsights();
  ai.addTelemetryInitializer((item) => {
    item.tags = item.tags ?? {};
    item.tags["ai.cloud.role"] = "frontend-consent-admin";
  });
  ai.trackPageView();
  initialised = true;
}
